import { createContext, useContext } from "react"

// =============================================================================
// Context
// =============================================================================

export type PageContextValue = {
  /** Page hierarchy — `"primary"` for top-level pages, `"secondary"` for nested ones. Affects `PageBody` padding. */
  is: "primary" | "secondary"
  /** Allow page content to span the full width of the page. If false, `PageBody` and `PageFooter` content is constrained to a max-width of 90rem (1440px). */
  fullWidth: boolean
}

export const PageContext = createContext<PageContextValue>({
  is: "primary",
  fullWidth: true
})

export function usePageContext(): PageContextValue {
  return useContext(PageContext)
}
